module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "الخصوصية",
	"footer.privacy.url": "https://www.grohe-gcc.com/ar_sa/company/privacy.html",
	"footer.disclaimer.text": "إخلاء المسؤولية",
	"footer.disclaimer.url": "https://www.grohe-gcc.com/ar_sa/company/legal-info.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "معدّ أنظمة المياه من GROHE",
	"homepage.introtext": "أجب على بضعة أسئلة أدناه لتعدّ نظام المياه من GROHE الذي يلائم إحتياجاتك.",
	"homepage.buttonStart": "إبدأ",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "لم يتم العثور على الصفحة",
	"404.link.goBack": "العودة إلى الصفحة الرئيسية",
	"configurator.button.seeResults": "See results",
	"question1.question": " هل لديك إمدادات للمياه الباردة والساخنة في مطبخك؟",
	"question1.option1.text": "لدي إمدادات للمياه الباردة والساخنة في مطبخي",
	"question1.option2.text": "لدي إمدادات للمياه الباردة فقط",
	"question2.question": "ما هو نوع المياه الذي تبحث عنه؟",
	"question2.option1.text": "مياه ساخنة مغلية لتحضير الطعام والمشروبات",
	"question2.option2.text": "مياه مبرّدة وفوارة صالحة للشرب",
	"question2.option3.text": "مياه مبرّدة وفوارة إضافة إلى مياه ساخنة مغلية",
	"question3.question": "هل تريد الإحتفاظ بحنفية المطبخ الخاصة بك؟",
	"question3.option1.text": "أريد الإحتفاظ بها",
	"question3.option2.text": "أريد تركيب نموذجاً جديداً",
	"question4.question": "ماذا يجب أن تكون حنفيتك الأساسية؟",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "ما هو تصميم الفتحة المفضل لديك؟",
	"question5.option1.text": "فتحة على شكل L",
	"question5.option2.text": "فتحة على شكل U",
	"question5.option3.text": "فتحة على شكل C",
	"question6.question": "ما هو تصميم الفتحة المفضل لديك؟",
	"question6.option1.text": "فتحة على شكل L",
	"question6.option2.text": "فتحة على شكل U",
	"question6.option3.text": "فتحة على شكل C",
	"question7.question": "ما هي اللمسة النهائية المفضلة لديك؟",
	"question7.option1.text": "كروم",
	"question7.option2.text": "فولاذ صلب",
	"question8.question": "ما هو حجم سخان المياه الذي تحتاجه؟",
	"question8.option1.text": "حجم وسط (٣ لترات)",
	"question8.option2.text": "حجم كبير (٥,٥ لترات)",
	"question9.question": "Would you like to have an additional filter to soften and enhance the water?",
	"question9.option1.text": "Yes",
	"question9.option2.text": "No",
	"results.title": "{productGroupsCount, plural, \none {نتيجتك} \nother {نتائجك}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "للحصول على التركيب الملائم، تحتاج إلى:",
	"results.newConfiguration.title": "هل تريد إعداد نظام مياه جديد؟",
	"results.newConfiguration.buttonText": "قم بإعداد نظام مياه جديد",
	"results.product.number": "{number} :رقم المنتج",
	"results.product.button.productInformation": "معلومات عن المنتج",
	"results.product.button.dealerLocator": "قم بإيجاد صالة عرض",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Product Information",
	"results.product.dealer": "Find a showroom",
	"hatchModal.title": "-غير متوفر-",
	"hatchModal.btnText": "-غير متوفر-",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/water.ar_sa.json
// module id = 769
// module chunks = 0